import {
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_CHECK,
  AUTH_ERROR,
  AUTH_GET_PERMISSIONS,
} from 'admin-on-rest'

import * as firebase from 'firebase'

import { createHashHistory } from 'history'
export const history = createHashHistory()

export default (type, params) => {
  // console.log('auth client => ', type, ' => ', params)
  if (type === AUTH_LOGIN) {
    const { username, password } = params
    return firebase
      .auth()
      .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
      .then(() =>
        firebase.auth().signInWithEmailAndPassword(username, password),
      )
      .then((userCredential) => {
        const user = userCredential.user
        if (user) {
          return firebase
            .database()
            .ref('permissions/' + user.uid)
            .once('value')
            .then(function (response) {
              if (response.exists()) {
                // console.log('user permissions', Object.keys(response.val())[0])
                localStorage.setItem('role', Object.keys(response.val())[0])
              } else {
                // console.log('no permissions for user ' + user.uid)
                localStorage.setItem('role', 'student')
              }
            })
            .catch((err) => {
              // console.log('Permissions not set' + err)
              localStorage.setItem('role', 'student')
            })
        }
        return user
      })
    // .catch((err) => console.error('Cannot login', err))
  }

  if (type === AUTH_LOGOUT) {
    localStorage.removeItem('role')
    return firebase.auth().signOut()
  }

  if (type === AUTH_ERROR) {
    //TODO -> See what errors we should handle here
    return Promise.resolve()
  }

  if (type === AUTH_CHECK) {
    // console.log('check ', firebase.auth().currentUser)
    return firebase.auth().currentUser ? Promise.resolve() : Promise.reject()
  }

  if (type === AUTH_GET_PERMISSIONS) {
    const role = localStorage.getItem('role')
    // console.log('role', role)
    if (!role) {
      history.push('/login')
    }
    return Promise.resolve(role)
  }

  return Promise.reject('Unkown method')
}



// WEBPACK FOOTER //
// ./src/rest/authClient.js